<!--
 * @Author: baiwei
 * @Date: 2020-04-24 11:16:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-13 11:24:44
 * @description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <Modal v-model="show"
           :title="$t(`${isCreate?'创建':'编辑'}用户组`)"
           @on-ok="submit"
           :loading="loading">
        <Form ref="form"
              label-position="right"
              :model="formData"
              :rules="validates"
              :label-width="150"
              class="createug-pack"
              @submit.native.prevent>
            <!-- <FormItem :label="$t('上级组')+'：'"
                        prop="parentId">
                <Select v-model="formData.parentId">
                    <Option v-for="item in groupList" :value="item.groupSid" :key="item.groupSid">{{ item.groupName }}</Option>
                </Select>
            </FormItem> -->
            <FormItem :label="$t('用户组名称')+'：'"
                      prop="groupName">
                <Input v-model="formData.groupName"
                       :maxlength='32'></Input>
            </FormItem>
            <FormItem :label="$t('描述')+'：'"
                      prop="description">
                <Input v-model="formData.description"
                       type="textarea"
                       :maxlength='500'
                       :autosize="{minRows: 3, maxRows: 6}"></Input>
            </FormItem>
        </Form>
    </Modal>
</template>
<script>
// import { isPhone } from '@/service/validator'
import API from '@/service/api'
export default {
    name: 'edituser',
    components: {
    },
    data () {
        return {
            show: false,
            loading: true,
            isCreate: true,
            formData: {
                // parentId: null,
                groupName: null,
                description: null
            },
            // groupList: [],
            validates: {
                groupName: [
                    { required: true, message: this.$i18n.t('请输入'), trigger: 'blur' }
                    // { min: 2, max: 64, message: '输入长度必须介于2~64个字符', trigger: 'blur' }
                ]
            }
        }
    },
    created () { },
    methods: {
        changeLoading () {
            this.loading = false
            this.$nextTick(() => {
                this.loading = true
            })
        },
        open (inf) {
            // this.axios.get(this.urlFormat(API.ACCESS_USERGROUPS, false), { params: { parentSidNotNull: true, includeDefaultGroup: true } }).then(res => {
            //     this.groupList = res
            // })
            if (inf) {
                this.isCreate = false
                this.formData = {
                    groupSid: inf.groupSid,
                    // parentId: inf.parentId,
                    groupName: inf.groupName,
                    description: inf.description
                }
            }
            this.show = true
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.changeLoading()
                    return
                }
                // const { parentId, groupName, description } = this.formData
                const { groupName, description } = this.formData
                const params = {
                    // parentId: parentId,
                    groupName: groupName,
                    description: description
                }
                this.isCreate ? this.create(params) : this.edit(params)
            })
        },
        create (params) {
            this.axios.post(this.urlFormat(API.ACCESS_USERGROUPS, false), params).then(res => {
                if (res.status) {
                    this.$emit('refresh')
                    this.show = false
                } else {
                    this.changeLoading()
                }
            }).catch(() => {
                this.changeLoading()
            })
        },
        edit (params) {
            this.axios.put(this.urlFormat(API.ACCESS_USERGROUP, false, [this.formData.groupSid]), params).then(res => {
                if (res.status) {
                    this.$emit('refresh')
                    this.show = false
                } else {
                    this.changeLoading()
                }
            }).catch(() => {
                this.changeLoading()
            })
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.isCreate = true
                this.$refs.form.resetFields()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.createug-pack {
    padding-right: 50px;
}
</style>
